import React from 'react';
import { 
  Box, 
  Typography, 
  Button,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  Paper 
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';

const ProductDetailCartosat2B = () => {
  const history = useHistory();

  return (
    <Box sx={{ maxWidth: '1200px', mx: 'auto', p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          sx={{
            color: '#4287f5',
            textTransform: 'none',
            fontWeight: 500
          }}
          onClick={() => history.push('/products')}
        >
          Products &gt; Cartosat-2B
        </Button>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
          Product Description
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.primary', lineHeight: 1.6 }}>
          Cartosat-2B is a high-resolution Earth observation satellite developed by the Indian Space Research Organisation (ISRO). Launched in 2010, it is part of the Cartosat-2 series designed for cartographic applications, urban planning, infrastructure development, and land information system management.
          <br /><br />
          The satellite features a panchromatic camera capable of capturing high-resolution imagery with excellent geometric accuracy. Cartosat-2B operates in a sun-synchronous orbit, providing systematic coverage of the Earth's surface with the ability to revisit any location within a few days.
          <br /><br />
          With its agile imaging capability, Cartosat-2B can be steered along and across the track, enabling rapid coverage of large areas and stereo imaging for 3D terrain modeling. The satellite's high-resolution imagery supports applications in defense, disaster management, infrastructure monitoring, and precision agriculture.
        </Typography>
      </Box>

      <TableContainer component={Paper} sx={{ mb: 4, border: '1px solid #d0d7de', boxShadow: 'none' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f0f4fa' }}>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Geographical Coverage</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Image Resolution</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Swath Width</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Revisit Frequency</TableCell>
              <TableCell align="center" sx={{ fontWeight: 600, color: '#1976d2' }}>Data Format</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell align="center">Global*</TableCell>
              <TableCell align="center">0.8 m x 0.8 m</TableCell>
              <TableCell align="center">9.6 km</TableCell>
              <TableCell align="center">4-5 days</TableCell>
              <TableCell align="center">GeoTIFF</TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={5} sx={{ fontStyle: 'italic', fontSize: '0.85rem', color: 'gray', py: 1 }}>
                *Global coverage available. AOI outside India requires additional processing time.
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table sx={{ mt: 4 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f0f4fa' }}>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Spectral Band</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Wavelength Range</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#1976d2' }}>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow hover>
              <TableCell>Panchromatic (PAN)</TableCell>
              <TableCell>500 - 850 nm</TableCell>
              <TableCell>High-resolution panchromatic band for detailed imaging and cartographic applications.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Button
          variant="contained"
          sx={{
            bgcolor: '#1976d2',
            color: 'white',
            py: 1,
            px: 4,
            '&:hover': {
              bgcolor: '#1565c0'
            }
          }}
        >
          Order Imagery
        </Button>
      </Box>
    </Box>
  );
};

export default ProductDetailCartosat2B;

